var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-context-menu-blank"},[_c(_vm.comp,{tag:"component",attrs:{"params":_vm.params}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }